import { registerSmarticoProfileEventHandler } from '~/handlers/register-smartico-profile-event';
import { NativeEvent } from '~/shared/NativeBridge/NativeEvent';
import { SmarticoProfileEvent } from '~/shared/smartico/smartico-profile-event';
import { isRunningInIosNativeApp } from '~/utils/browserInfo';

export const useSmarticoProfileEvent = () => {
  const { userId } = useUserData();

  const sendLoginEvent = async (): Promise<void> => {
    if (!NativeEvent.isNativeApp()) return;

    // Plataforma via deteccao local (user-agent + bridge), NAO via atribuicao
    // AppsFlyer: o recado `appsflyerUid` da bridge e suprimido quando o
    // usuario nega o ATT (iOS), o que deixava `journeyStore.appsflyer.platform`
    // vazio e silenciava este evento para praticamente todo iOS.
    const platform = isRunningInIosNativeApp() ? 'IOS' : 'ANDROID';

    const userExtId = String(userId.value || '');

    if (!userExtId) return;

    try {
      await registerSmarticoProfileEventHandler({
        event: SmarticoProfileEvent.UpdateProfile,
        user_ext_id: userExtId,
        payload: { core_custom_prop25: platform },
      });
    } catch (e) {
      console.error('[smartico-profile-event] failed', e);
    }
  };

  return { sendLoginEvent };
};
